import styled from 'styled-components'
import DrawerComponent from 'react-modern-drawer'
import { white, black, purple, purpleDark, gray } from 'theme/colors'

export const Drawer = styled(DrawerComponent)`
  width: 417px !important;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 417px;
  height: 100%;
  background: ${white};
  box-shadow: 0px 4px 73px rgba(0, 0, 0, 0.13);
  border-radius: 6px;
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 65px 20px 0px 20px;
  width: 417px;
  height: 131px;
  background: ${white};
`

export const BackButton = styled.button`
  width: 27.07px;
  height: 32px;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: absolute;
  left: 35px;
`

export const Title = styled.h2`
  width: 100%;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 154.7%;
  text-align: center;
  color: ${black};
  margin: 0;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 20px 30px 20px;
  width: 100%;
  flex: 1;
`

export const IconContainer = styled.div`
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 113px;
`

export const SuccessTitle = styled.h1`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 154.7%;
  text-align: center;
  letter-spacing: 0.01em;
  color: ${black};
  margin: 35px 0 0 0;
`

export const Message = styled.p`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 154.7%;
  text-align: center;
  letter-spacing: 0.01em;
  color: ${gray};
  margin: 35px 0 0 0;
  width: 180px;
`

export const RefundMessage = styled.p`
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 154.7%;
  text-align: center;
  letter-spacing: 0.01em;
  color: ${purpleDark};
  margin: 14px 0 0 0;
  width: 100%;
`

export const LinkButton = styled.button`
  font-family: 'Poppins';
  font-style: normal;
  font-size: 18px;
  line-height: 154.7%;
  text-align: center;
  letter-spacing: 0.01em;
  text-decoration-line: underline;
  color: ${purpleDark};
  background: none;
  border: none;
  cursor: pointer;
  margin-top: auto;
  margin-bottom: 16px;
  &:hover {
    opacity: 0.9;
  }
`

export const ButtonLineWrapper = styled.div`
  width: 230px;
  margin-top: 20px;
`

export const ActionButton = styled.button`
  width: 230px;
  height: 53px;
  background: ${purple};
  border-radius: 6px;
  border: none;
  font-family: 'Poppins';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 154.7%;
  text-align: center;
  color: ${white};
  cursor: pointer;
  margin-top: 0;

  &:hover {
    opacity: 0.9;
  }
`
